'use client';

import { SessionProvider } from 'next-auth/react';
import type { Session } from 'next-auth';

export interface AuthContextProps {
  children: React.ReactNode;
  // Optional server-seeded session. When OMITTED (undefined), SessionProvider
  // fetches the session client-side via /api/auth/session after mount. We do
  // that deliberately at the root so the SSR critical path of every route is
  // free of a session read — with `strategy: 'database'`, `auth()` is a D1
  // query, and calling it in the root layout put that round-trip on the cold
  // path of even public pages (/cars, /spot, /stock, …). The nav right slot
  // (DefaultRightSlot) already handles `status === 'loading'` by reserving
  // space, so deferring the seed only delays the avatar by one fetch, with no
  // layout shift. NB: pass `undefined` (omit), never `null` — `null` seeds the
  // provider as unauthenticated and suppresses the client fetch, so a signed-in
  // user would render as logged out.
  session?: Session | null;
}

export default function AuthContext({ children, session }: AuthContextProps) {
  return <SessionProvider session={session}>{children}</SessionProvider>;
}
